import { render, staticRenderFns } from "./goodsTraceDetail.vue?vue&type=template&id=74a935b1&scoped=true"
import script from "./goodsTraceDetail.vue?vue&type=script&lang=js"
export * from "./goodsTraceDetail.vue?vue&type=script&lang=js"
import style0 from "./goodsTraceDetail.vue?vue&type=style&index=0&id=74a935b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a935b1",
  null
  
)

export default component.exports